import { prisma } from "@/lib/db";
import { NextRequest, NextResponse } from "next/server";

export async function GET(request: NextRequest) {
  try {
    const searchParams = request.nextUrl.searchParams;
    const groupId = searchParams.get("groupId");

    const where = groupId ? { groupId } : {};

    const problems = await prisma.problem.findMany({
      where,
      orderBy: [{ groupId: "asc" }, { sequenceInGroup: "asc" }],
      include: {
        group: {
          select: { name: true },
        },
      },
    });

    return NextResponse.json(problems);
  } catch (error) {
    console.error("Error fetching problems:", error);
    return NextResponse.json(
      { error: "Failed to fetch problems" },
      { status: 500 }
    );
  }
}

export async function POST(request: NextRequest) {
  try {
    const body = await request.json();
    const { groupId, problemText, answer, answerDescription, sequenceInGroup } = body;

    if (!groupId || !problemText || !answer || !answerDescription) {
      return NextResponse.json(
        { error: "Missing required fields: groupId, problemText, answer, answerDescription" },
        { status: 400 }
      );
    }

    // Get the next sequence number if not provided
    let sequence = sequenceInGroup;
    if (sequence === undefined) {
      const lastProblem = await prisma.problem.findFirst({
        where: { groupId },
        orderBy: { sequenceInGroup: "desc" },
      });
      sequence = lastProblem ? lastProblem.sequenceInGroup + 1 : 0;
    }

    const problem = await prisma.problem.create({
      data: {
        groupId,
        problemText,
        answer,
        answerDescription,
        sequenceInGroup: sequence,
      },
    });

    return NextResponse.json(problem, { status: 201 });
  } catch (error) {
    console.error("Error creating problem:", error);
    return NextResponse.json(
      { error: "Failed to create problem" },
      { status: 500 }
    );
  }
}

// Bulk create problems
export async function PUT(request: NextRequest) {
  try {
    const body = await request.json();
    const { problems } = body;

    if (!Array.isArray(problems) || problems.length === 0) {
      return NextResponse.json(
        { error: "problems array is required" },
        { status: 400 }
      );
    }

    const created = await prisma.problem.createMany({
      data: problems.map((p: {
        groupId: string;
        problemText: string;
        answer: string;
        answerDescription: string;
        sequenceInGroup: number;
      }) => ({
        groupId: p.groupId,
        problemText: p.problemText,
        answer: p.answer,
        answerDescription: p.answerDescription,
        sequenceInGroup: p.sequenceInGroup,
      })),
    });

    return NextResponse.json({ created: created.count }, { status: 201 });
  } catch (error) {
    console.error("Error bulk creating problems:", error);
    return NextResponse.json(
      { error: "Failed to bulk create problems" },
      { status: 500 }
    );
  }
}
